
interface Props {
  children: JSX.Element
  state: "pending" | "success" | "error" | "warning"
}

export default function Chip({ state, children }: Props) {
  return (
    <div className={`w-max px-2 py-1 text-xs
    ${state === "pending" && "text-[#2D7AFF] bg-[#D5EAFF]"}
    ${state === "success" && "text-[#23C45E] bg-[#D3FCD2]"}
    ${state === "error" && "text-[#D33921] bg-[#FCE5D2]"}
    ${state === "warning" && "text-[#E5A800] bg-[#FDF5CA]"}
     rounded-sm`}>
      {children}
    </div>
  )
}